<div class="container-fluid page">
  <mat-card class="payment-card">
    <mat-toolbar class="custom-toolbar">
      <mat-toolbar-row>
        <span>Profile Details</span>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-card-content class="ps-3">
      <div class="row my-3">
        <div class="col-md-4">Name:</div>
        <div class="col-md-8">
          {{ userInfo.userName }}
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4">Email:</div>
        <div class="col-md-8">
          {{ userInfo.userEmail }}
        </div>
      </div>
      <div class="row mb-3" *appHasAccess="'reset-password'">
        <div class="col-md-4">Password:</div>
        <div class="col-md-8">
          <button mat-raised-button (click)="resetPasswordDialog()">
            Reset Password
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
